import React from 'react';
import { ShieldCheck, User, Building, Database, Server, Share2, Cookie, UserCheck, Phone, Mail } from 'lucide-react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <>
      <div className="privacy-container">
        <div className="privacy-wrapper">
          <h1 className="privacy-title">Privacy Policy</h1>
          
          <div className="privacy-intro">
            <ShieldCheck className="intro-icon" />
            <p>
              At <strong>PROPERTECK</strong>, we respect the privacy of all our customers – both individual (personal) customers and corporate / business clients. We are committed to protecting the personal and business information you share with us. This Privacy Policy explains how we collect, use, and safeguard your data.
            </p>
          </div>

          <div className="privacy-content">
            <div className="policy-section">
              <h2 className="section-title"><Database className="section-icon" /> Information We Collect</h2>
              <p className="section-description">We may collect the following information to provide and improve our services.</p>

              <div className="subsection">
                <h3 className="subsection-title"><User className="subsection-icon" /> For Personal Customers</h3>
                <ul>
                  <li>Full name, contact number, email address</li>
                  <li>Shipping and billing address</li>
                  <li>Payment details (processed securely via trusted payment gateways such as PayHere)</li>
                  <li>Order history and communication records</li>
                </ul>
              </div>

              <div className="subsection">
                <h3 className="subsection-title"><Building className="subsection-icon" /> For Corporate / Business Customers</h3>
                <ul>
                  <li>Company name, registration details, VAT / tax details</li>
                  <li>Business contact person’s name, phone number, and email address</li>
                  <li>Delivery and billing addresses</li>
                  <li>Purchase orders, invoices, and payment records</li>
                </ul>
              </div>
               <div className="subsection">
                <h3 className="subsection-title"><Server className="subsection-icon" /> Technical Data (for all customers)</h3>
                <ul>
                  <li>IP address, browser type, device information, and website usage data (for site analytics and security).</li>
                </ul>
              </div>
            </div>

            <div className="policy-section">
              <h2 className="section-title"><Server className="section-icon" /> How We Use Your Information</h2>
               <p className="section-description">We use the collected information to:</p>
              <ul>
                <li>Process and deliver orders efficiently</li>
                <li>Provide customer and technical support</li>
                <li>Manage accounts for both personal and business customers</li>
                <li>Issue invoices, receipts, and handle warranty or after-sales services</li>
                <li>Communicate about order updates, promotions, or policy changes (only if you opt in)</li>
                <li>Improve our website, products, and services</li>
                <li>Comply with legal, tax, and security obligations</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2 className="section-title"><ShieldCheck className="section-icon" /> Data Protection</h2>
              <ul>
                  <li>We do not store sensitive payment details such as credit/debit card numbers on our servers.</li>
                  <li>All online transactions are handled via secure and encrypted payment gateways.</li>
                  <li>We take reasonable technical and administrative measures to safeguard customer information from unauthorized access, disclosure, or misuse.</li>
              </ul>
            </div>
            
            <div className="policy-section">
              <h2 className="section-title"><Share2 className="section-icon" /> Sharing of Information</h2>
              <ul>
                  <li>We do not sell or rent your personal or business data to third parties.</li>
                  <li>We may share information with trusted service providers (e.g., delivery, courier, or payment partners) only to fulfill orders and provide services.</li>
                  <li>Information may be disclosed if required by law or to protect the rights and safety of our customers and business.</li>
              </ul>
            </div>

             <div className="policy-section">
              <h2 className="section-title"><Cookie className="section-icon" /> Cookies</h2>
              <p>Our website may use cookies to improve browsing experience and website performance. You can disable cookies in your browser settings; however, some features of the website may not work as intended.</p>
            </div>

             <div className="policy-section">
              <h2 className="section-title"><UserCheck className="section-icon" /> Your Rights</h2>
               <p>Both individual and corporate customers have the right to:</p>
              <ul>
                  <li>Access and review the personal or business data we hold</li>
                  <li>Request correction of inaccurate information</li>
                  <li>Request deletion of data where legally applicable</li>
                  <li>Opt out of receiving promotional communications</li>
              </ul>
            </div>

             <div className="policy-section contact-section">
              <h2 className="section-title">Contact Us</h2>
               <p>For any questions or concerns about this Privacy Policy or how we handle your data, please contact us:</p>
               <div className="contact-details">
                  <p><Phone className="contact-icon" /> 077 949 0055 / 037 434 0055</p>
                  <p><Mail className="contact-icon" /> info@properteck.lk</p>
               </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;

